import { styled, css } from 'styled-components'
import { m } from 'motion/react'

type ContainerProps = {
  $position: string | undefined
  $wide: boolean
  $isSelected: boolean
}

export const Container = styled(m.div)<ContainerProps>`
  position: absolute;
  height: fit-content;
  width: ${({ $wide }) => ($wide ? '220px' : '182px')};
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 8px;
  box-shadow:
    0 4px 13px 0 rgba(43, 5, 20, 0.04),
    0 3px 14px 0 rgba(43, 5, 20, 0.09);
  cursor: auto;
  pointer-events: ${({ $isSelected }) => ($isSelected ? 'auto' : 'none')};
  ${({ $position }) => {
    switch ($position) {
      case 'top left':
        return css`
          top: 0;
          left: 0;
        `
      case 'top right':
        return css`
          top: 0;
          right: 0;
        `
      case 'top center':
        return css`
          top: 0;
        `
      case 'bottom left':
        return css`
          bottom: 0;
          left: 0;
        `
      case 'bottom right':
        return css`
          bottom: 0;
          right: 0;
        `
    }
  }};
`

export const Title = styled.div`
  color: ${({ theme }) => theme.colors.secondaryDark};
  font-size: 17px;
  font-weight: 600;
  padding: 20px 0 8px 20px;
`

export const Options = styled.div`
  padding-left: 14px;
`

export const Separator = styled.div`
  width: 142px;
  height: 1px;
  background-color: ${({ theme }) => theme.colors.grayMedium};
`
